import { themeConfig } from '@gap/shared/theme'
import { getContrastRatio, rgbToHex } from '@mui/material/styles'
import { createTheme } from '@mui/material/styles'

const contrastThreshold = 3
export function getContrastText(background: string) {
   const light = createTheme({ palette: { mode: 'light', gap: {} as any, passion: {} as any } }).palette
   const dark = createTheme({ palette: { mode: 'dark', gap: {} as any, passion: {} as any } }).palette

   const contrastText =
      getContrastRatio(background, dark.text.primary) >= contrastThreshold
         ? dark.text.primary
         : light.text.primary

   if (import.meta.env.NODE_ENV !== 'production') {
      const contrast = getContrastRatio(background, contrastText)
      if (contrast < 3) {
         console.error(
            [
               `MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`,
               'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.',
               'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast',
            ].join('\n')
         )
      }
   }

   return rgbToHex(contrastText)
}

/**
 * Ensure we set the correct colours on a custom textfield depending on wether the menu is visible or not.
 */
export const TextFieldHoverStyles = {
   'visible': {
      '& .MuiOutlinedInput-notchedOutline': {
         // This is the selected state
         border: `2px solid ${themeConfig.primary[600]} !important`
      },
   },
   'not visible': {
      '& .MuiOutlinedInput-notchedOutline': {
         // This is the normal state
         border: `1px solid ${themeConfig.light.borderColour} !important`,
      },
      '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
         // This is the state on hover
         border: `1px solid ${themeConfig.light.borderColourHover} !important`
      }
   }
}
